/**
 * 観測所一覧
 */
import Repository from "./../JsonRepository";
import Logger from "./../../lib/logger";
import Util from "./../../lib/util";

const resource = "";

export default {
  /**
   * 雨量観測値過去情報一覧 取得
   * @param obsFcd 伝送記号
   * @param date 取得開始日
   */
  getSelectedTmRainPast(obsFcd, date) {
    let datePath = Util.formatDate(date, "YYYYMMDD/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "tmlist/past/rn/" + datePath + obsFcd + ".json";

    Logger.debug("getSelectedTmRainPast(" + obsFcd + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 流域平均雨量観測値過去情報一覧 取得
   * @param obsFcd 伝送記号
   * @param date 取得開始日
   */
  getSelectedTmBsnPast(obsFcd, date) {
    let datePath = Util.formatDate(date, "YYYYMMDD/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "tmlist/past/bsn/" + datePath + obsFcd + ".json";

    Logger.debug("getSelectedTmBsnPast(" + obsFcd + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 積雪深観測値過去情報一覧 取得
   * @param obsFcd 伝送記号
   * @param date 取得開始日
   */
  getSelectedTmSnowPast(obsFcd, date) {
    let datePath = Util.formatDate(date, "YYYYMMDD/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "tmlist/past/snw/" + datePath + obsFcd + ".json";

    Logger.debug("getSelectedTmSnowPast(" + obsFcd + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 通常水位観測値過去情報一覧 取得
   * @param obsFcd 伝送記号
   * @param date 取得開始日
   */
  getSelectedTmStagePast(obsFcd, date) {
    let datePath = Util.formatDate(date, "YYYYMMDD/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "tmlist/past/stg/" + datePath + obsFcd + ".json";

    Logger.debug("getSelectedTmStagePast(" + obsFcd + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 水質観測値過去情報一覧 取得
   * @param obsFcd 伝送記号
   * @param date 取得開始日
   */
  getSelectedTmWtrQualPast(obsFcd, date) {
    let datePath = Util.formatDate(date, "YYYYMMDD/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "tmlist/past/qwtr/" + datePath + obsFcd + ".json";

    Logger.debug("getSelectedTmWtrQualPast(" + obsFcd + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * ダム諸量観測値過去情報一覧 取得
   * @param obsFcd 伝送記号
   * @param date 取得開始日
   */
  getSelectedTmDamPast(obsFcd, date) {
    let datePath = Util.formatDate(date, "YYYYMMDD/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "tmlist/past/dam/" + datePath + obsFcd + ".json";

    Logger.debug("getSelectedTmDamPast(" + obsFcd + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 海岸観測値過去情報一覧 取得
   * @param obsFcd 伝送記号
   * @param date 取得開始日
   */
  getSelectedTmCoastPast(obsFcd, date) {
    let datePath = Util.formatDate(date, "YYYYMMDD/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "tmlist/past/coast/" + datePath + obsFcd + ".json";

    Logger.debug("getSelectedTmCoastPast(" + obsFcd + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * レーダ流域平均雨量観測値過去情報一覧 取得
   * @param obsFcd 伝送記号
   * @param date 取得開始日
   */
  getSelectedTmRdBsnPast(obsFcd, date) {
    let datePath = Util.formatDate(date, "YYYYMMDD/");
    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "tmlist/past/rdbsn/" + datePath + obsFcd + ".json";

    Logger.debug("getSelectedTmRdBsnPast(" + obsFcd + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 都道府県市町村情報取得
   * @param prefCd 都道府県コード
   */
  getPrefTwnInfo(prefCd) {
    let path = "obslist/idx/pref/twn/" + prefCd + ".json";

    Logger.debug("json getPrefTwnInfo(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 都道府県別超過情報取得
   * @param prefCd 都道府県コード
   * @param appTime 観測日時(ファイル取得用)
   */
  getPrefOverInfo(prefCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");

    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "obslist/overlist/pref/" + datePath + prefCd + ".json";

    Logger.debug("json getPrefOverInfo(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 市町村別超過情報取得
   * @param twnCd 市町村コード
   * @param appTime 観測日時(ファイル取得用)
   */
  getTwnOverInfo(twnCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");

    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "obslist/overlist/twn/" + datePath + twnCd + ".json";

    Logger.debug("json getTwnOverInfo(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 都道府県別/市町村別水系情報取得
   * @param key 検索条件（都道府県 OR 市町村）
   * @param isPref 検索条件（都道府県で検索の場合true、市町村で検索の場合false）
   */
  getRsysInfo(key, isPref) {
    let path = "";
    if (isPref) {
      path = "obslist/idx/rsys/pref/" + key + ".json";
    } else {
      path = "obslist/idx/rsys/twn/" + key + ".json";
    }

    Logger.debug("json getRsysInfo(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 河川別情報取得
   * @param rsysCd 水系番号
   */
  getRvrInfo(rsysCd) {
    let path = "obslist/idx/rsys/rsys/" + rsysCd + ".json";

    Logger.debug("json getRvrInfo(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 水系別超過情報取得
   * @param rsysCd 水系番号
   * @param appTime 観測日時(ファイル取得用)
   */
  getRsysOverInfo(rsysCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");

    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "obslist/overlist/rsys/" + datePath + rsysCd + ".json";

    Logger.debug("json getRsysOverInfo(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 河川別超過情報取得
   * @param rvrCd 河川番号
   * @param appTime 観測日時(ファイル取得用)
   */
  getRvrOverInfo(rvrCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");

    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "obslist/overlist/rvr/" + datePath + rvrCd + ".json";

    Logger.debug("json getRvrOverInfo(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 都道府県市町村別観測所情報取得
   * @param twnCd 市町村コード
   */
  getObsDatasByTown(twnCd) {
    let path = "obslist/obs/twnlist/" + twnCd + ".json";

    Logger.debug("json getObsDatasByTown(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 都道府県市町村別テレメータ情報取得
   * @param twnCd 市町村コード
   * @param appTime 観測日時(ファイル取得用)
   */
  getTmDatasByTown(twnCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");

    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "obslist/tm/twnlist/" + datePath + twnCd + ".json";

    Logger.debug("json getTmDatasByTown(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 水系河川別観測所情報取得
   * @param rvrCd 河川番号
   */
  getObsDatasByRvr(rvrCd) {
    let path = "obslist/obs/rvrlist/" + rvrCd + ".json";

    Logger.debug("json getObsDatasByRvr(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
  /**
   * 水系河川別テレメータ情報取得
   * @param rsysCd 水系番号
   * @param appTime 観測日時(ファイル取得用)
   */
  getTmDatasByRsys(rsysCd, appTime) {
    let datePath = Util.formatDate(appTime, "YYYYMMDD/HHmm/");

    if (process.env.NODE_ENV === "development") {
      // ローカルで動作させる場合は日時を指定しない
      datePath = "";
    }
    let path = "obslist/tm/rsyslist/" + datePath + rsysCd + ".json";

    Logger.debug("json getTmDatasByRsys(" + path + ")");
    return Repository.get(`${resource}` + path);
  },
};
